import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Button, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { PageNotFoundIllustration } from '../assets/illustrations';

// ----------------------------------------------------------------------
export default function NotLoggedIn() {
  return (
    <>
      <Helmet>
        <title> Not Logged In | AT Dealer Portal</title>
      </Helmet>

      <MotionContainer
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            You have been logged out!
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            Please return to AT Dealer and login to view this page.
          </Typography>
        </m.div>
        <a href="https://atdealer.net" target="_blank" rel="noopener noreferrer">
          <Button size="large" variant="contained">
            Return to AT Dealer
          </Button>
        </a>
      </MotionContainer>
    </>
  );
}
